import { TComponentTagProcessInfo } from '@monorepo/types';
import { TTableTreeModel } from '@monorepo/ui';
import { ModifiersZTableModel } from 'libs/ui/src/lib/table/models/table.modifier';
export const COMPONENT_TAG_HISTORY_TABLE_MODEL = {
  createTableModel(items: TComponentTagProcessInfo[]): TTableTreeModel<TComponentTagProcessInfo> {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          { type: 'TEXT_CELL', text: 'component_tag_history.table.department' },
          { type: 'TEXT_CELL', text: 'component_tag_history.table.domrole' },
          { type: 'TEXT_CELL', text: 'component_tag_history.table.wip_in' },
          { type: 'TEXT_CELL', text: 'component_tag_history.table.wip_out' },
          { type: 'TEXT_CELL', text: 'component_tag_history.table.wip_out_pending' },
        ],
      },
      (item) => {
        const { dpt_id, dom_role } = item.processDetail.process_info;
        const { wipIn, wipOut, wipOutPending } = item.wipInfo;

        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            { type: 'TEXT_CELL', text: dpt_id },
            { type: 'TEXT_CELL', text: dom_role },
            { type: 'TEXT_CELL', text: wipIn },
            { type: 'TEXT_CELL', text: wipOut },
            { type: 'TEXT_CELL', text: wipOutPending },
          ],
        };
      },
    );
  },
};
